import React from 'react';
import { Course } from '../../../types/grades';

interface CourseFlagsProps {
  course: Course;
  onChange: (updatedCourse: Course) => void;
}

export function CourseFlags({ course, onChange }: CourseFlagsProps) {
  return (
    <div className="flex flex-col gap-2 lg:col-span-4">
      <div className="flex flex-row gap-4">
        <label className="flex items-center gap-2 text-sm text-gray-600">
          <input
            type="checkbox"
            checked={course.isSpecialGrade || false}
            onChange={(e) => onChange({ ...course, isSpecialGrade: e.target.checked })}
            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          Special Grade
        </label>
        <label className="flex items-center gap-2 text-sm text-gray-600">
          <input
            type="checkbox"
            checked={course.isRetake || false}
            onChange={(e) => onChange({ ...course, isRetake: e.target.checked })}
            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          Retake
        </label>
      </div>
    </div>
  );
}